<template>
 <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '300px' : '150px'">
        <el-form-item label="采集源ID" prop="id" >
          <el-input :disabled="true" v-model="dataForm.id" placeholder="采集源ID" class="input-item"></el-input>
      </el-form-item>
         <el-form-item label="列表URL" prop="listJson" >
          <el-input v-model="dataForm.listJson" placeholder="列表URL" class="input-item"></el-input>
      </el-form-item>
      <el-form-item label="详情URL" prop="detailJson" >
          <el-input v-model="dataForm.detailJson" placeholder="详情URL" class="input-item"></el-input>
      </el-form-item>
      <el-form-item label="采集源名字" prop="resName" >
          <el-input :disabled="true" v-model="dataForm.resName" placeholder="采集源名字" class="input-item"></el-input>
      </el-form-item>
          <el-form-item label=" 第一次采集状态" prop="type">
          <el-radio-group v-model="dataForm.type">
          <el-radio :label="0">未采集过全部</el-radio>
          <el-radio :label="1">采集全部中</el-radio>
          <el-radio :label="2">采集全部完毕</el-radio>
        </el-radio-group> 
      </el-form-item>
      <el-form-item label=" 备注：采集时间区间，单位小时" prop="timeRange">
          <el-input v-model="dataForm.timeRange" placeholder="备注：采集时间区间，单位小时" class="input-item"></el-input>
      </el-form-item>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
      </el-form>
</template>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      imageType: ["jpg","jpeg","png","gif","bmp","webp"],
      visible: false,
      url: '',
      adImg: '',
      appLogo: '',
      dataForm: {
        id: '',
        listJson:'',
        detailJson: '',
        resName:'',
        type:'',
        timeRange:''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        listJson: [
          { required: true, message: '列表URL不能为空', trigger: 'blur' }
        ],
         detailJson: [
          { required: true, message: '详情URL不能为空', trigger: 'blur' }
        ],
         type: [
          { required: true, message: '第一次采集状态不能为空', trigger: 'blur' }
        ],
         timeRange: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  created(){
    this.init ()
  },
  methods: {
    init () {
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.getInfo()
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/cmsres/cmsres/config`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/cmsres/cmsres/config', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style>
  .input-item{
    width: 400px;
  }
</style>
